var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1862 9.84375L12.3988 10.6488C11.7688 11.2788 11.375 11.8125 11.375 13.125H9.625V12.6875C9.625 11.7163 10.0188 10.8413 10.6488 10.2113L11.7337 9.10875C12.0575 8.79375 12.25 8.35625 12.25 7.875C12.25 7.41087 12.0656 6.96575 11.7374 6.63756C11.4092 6.30937 10.9641 6.125 10.5 6.125C10.0359 6.125 9.59075 6.30937 9.26256 6.63756C8.93437 6.96575 8.75 7.41087 8.75 7.875H7C7 6.94674 7.36875 6.0565 8.02513 5.40013C8.6815 4.74375 9.57174 4.375 10.5 4.375C11.4283 4.375 12.3185 4.74375 12.9749 5.40013C13.6313 6.0565 14 6.94674 14 7.875C13.9987 8.61283 13.7063 9.32035 13.1862 9.84375ZM11.375 16.625H9.625V14.875H11.375M10.5 1.75C9.35093 1.75 8.21312 1.97633 7.15152 2.41605C6.08992 2.85578 5.12533 3.5003 4.31282 4.31282C2.67187 5.95376 1.75 8.17936 1.75 10.5C1.75 12.8206 2.67187 15.0462 4.31282 16.6872C5.12533 17.4997 6.08992 18.1442 7.15152 18.5839C8.21312 19.0237 9.35093 19.25 10.5 19.25C12.8206 19.25 15.0462 18.3281 16.6872 16.6872C18.3281 15.0462 19.25 12.8206 19.25 10.5C19.25 5.66125 15.3125 1.75 10.5 1.75Z",
    fill: "currentColor",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.2d61698a872b9b1ed455a05d9e3dce5c.svg";
export { ForwardRef as ReactComponent };